import React, { useState, useEffect, useContext } from 'react';
import { LanguageContext } from '../LanguageContext'; // For i18n
import axios from 'axios'; // If using the backend at all
// import '../components/CSS_FILE.css'; // For styling
import NavBar from '../components/NavBar'; // For top
import BottomBar from '../components/BottomBar'; // For bottom

// This relies on the frontend .env file
// Note that const cannot be above import statements
const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

function Exegesis() {
    const { t, setLanguage } = useContext(LanguageContext);
    // const variables
    // useEffect 
    return (
        <>
            <NavBar />
            <h3>{t('exegesis')}</h3>
        </>
    );
};

export default Exegesis;